interface ErrorMessageProps {
    message: string;
    onClose?: () => void;
}

const ErrorMessage = ({ message, onClose }: ErrorMessageProps) => (
    <div className='mb-10 display-flex width-100pct align-items-center justify-content-between bg-danger p-5 text-white'>
        <p data-testid='error-message'>{message}</p>
        <span
            data-testid='error-message-icon'
            onClick={onClose}
            className='rioglyph rioglyph-remove mx-5 cursor-pointer text-12'
        />
    </div>
);

export default ErrorMessage;
